import React from "react";

const HowItsDone = () => {
  const benefits = [
    {
      iconImageUrl: "/svgs/icons/form-fill.svg",
      title: "Fill Out The Form For a Free Consultation",
      description:
        "A Texas Debt Specialist will call you in the next few minutes to talk about your options",
    },
    {
      iconImageUrl: "/svgs/icons/build-plan.svg",
      title: "Build Your Custom Plan That Fits Your Budget",
      description:
        "Together we build a plan to effectively resolve high-interest debt with low monthly program payments",
    },
    {
      iconImageUrl: "/svgs/icons/debt-free.svg",
      title: "Graduate the Texas Debt Relief Program",
      description:
        "Resolve debt in as little as 24-48 Months. Get Started Today!",
    },
  ];

  return (
    <section className="bg-custom-lightGray py-40">
      <div className="container px-4 sm:px-8">
        <h2 className="text-5xl text-[#475569] font-semibold text-center capitalize">
          how it's done
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-y-10 gap-x-5 lg:gap-x-24 mt-16 mb-6">
          {benefits.map((data, index) => (
            <div className="text-center" key={index}>
              <img
                src={data.iconImageUrl}
                className="mx-auto min-h-[75px]"
                width={70}
                alt={data.title}
              />
              <h3 className="text-lg lg:text-2xl font-bold text-custom-primary my-2.5 !leading-normal">
                {data.title}
              </h3>
              <p className="text-lg font-medium text-custom-gray leading-normal">
                {data.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItsDone;
